import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { Text as NativeText, View } from 'react-native';
import configureFonts from "../styles/fonts";
var fonts = configureFonts();
var PnmacText = /** @class */function (_super) {
  __extends(PnmacText, _super);
  function PnmacText() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacText.prototype.setNativeProps = function (args) {
    return this.root && this.root.setNativeProps(args);
  };
  PnmacText.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      style = _a.style,
      larger = _a.larger,
      rest = __rest(_a, ["style", "larger"]);
    return /*#__PURE__*/React.createElement(View, {
      accessible: true,
      accessibilityLabel: typeof rest.children === 'string' ? rest.children : rest.idTag1
    }, /*#__PURE__*/React.createElement(NativeText, __assign({
      nativeID: rest.idTag1
    }, rest, {
      ref: function (c) {
        _this.root = c;
      },
      style: [__assign(__assign({}, fonts.regular), {
        color: "#003087",
        textAlign: 'left',
        fontSize: larger ? 16 : 14
      }), style]
    })));
  };
  return PnmacText;
}(React.Component);
export default PnmacText;